export default (state: any, {isLoading}: any) => ({
  ...state,
  socialMedia: {
    ...state.socialMedia,
    isLoading,
  },
});
